
import { defineComponent } from "vue";
import SearchFormCover from "./SearchFormCover.vue";
import FinishQuestionForm from "./FinishQuestionForm.vue";

export default defineComponent({
  name: "SearchFormViewer",
  components: {
    FinishQuestionForm,
    SearchFormCover
  }
});
